<template>
  <img
    :src="iconValues[index]"
    :width="width"
    height="auto"
    :title="name"
    :alt="name"
  />
</template>

<script>
const icons = import.meta.glob("@/assets/group-icons/*.png", {
  eager: true,
  import: "default"
});

export default {
  name: "GroupIcon",
  data() {
    return {
      icons
    };
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    width: {
      type: [Number, String],
      default: "40px"
    },
    name: {
      type: String,
      required: false
    }
  },
  computed: {
    iconValues() {
      return Object.values(this.icons);
    }
  }
};
</script>
